/* eslint-disable import/prefer-default-export */

import { compact, map, sortBy, toLower } from 'lodash';

import { transformPatientContactsFromPartners } from 'api/patient/transform';
import { casingFormat, formatName } from 'common/utils';

export const transformListPomRequestsStatus = ({ listPomRequestsStatus }) => {
  const { result, count } = listPomRequestsStatus;
  const data = map(result, (order) => {
    const { patient, partner } = order;
    const { firstName, lastName } = patient;

    return {
      ...order,
      partnerName: partner.partnerName,
      partnerId: partner.partnerUuid,
      patientName: `${casingFormat(formatName(lastName))}, ${casingFormat(formatName(firstName))}`,
    };
  });

  return { count, result: data };
};

export const transformPomRequestDetails = ({ getPomRequestByReferenceId: request }) => {
  const { events, practice, errors, shippingAddress, deliveryInstructions } = request;
  const { patient, externalPatientId, referenceId, prescriptions, originalRequestId } = request;
  const { patientContactFromPartner, partner, prxSalesRep } = request;

  const formattedPatientData = {
    ...patient,
    firstName: casingFormat(formatName(patient.firstName)),
    lastName: casingFormat(formatName(patient.lastName)),
    email: toLower(patient.email),
    contactsFromPartners: transformPatientContactsFromPartners(
      compact([patientContactFromPartner])
    ),
  };

  const eventData = map(events, (event) => ({
    id: event.id,
    actionItemType: event.actionItemType,
    interactionData: event.interactionData,
    timestamp: event.createdTimestamp,
    isProcessSuccess: true,
    user: event?.user,
    orderShipmentId: event?.orderShipmentId,
  }));

  const errorData = map(errors, (error) => ({
    id: error.id,
    actionItemType: error.actionItemType,
    interactionData: error.interactionData,
    timestamp: error.createdTimestamp,
    isProcessSuccess: false,
    user: error?.user,
  }));

  const sortedEvents = sortBy([...eventData, ...errorData], 'timestamp');
  const sortedErrors = sortBy(errorData, 'timestamp');

  return {
    patient: { ...formattedPatientData, externalPatientId },
    referenceId,
    prescriptions,
    practice: { practiceId: practice.practiceId, practiceName: practice.practiceName },
    partner: { partnerName: partner?.partnerName },
    // POM-6494: the order partner's current internal Sales User; null when unassigned.
    prxSalesRep: prxSalesRep ?? null,
    events: sortedEvents,
    errors: sortedErrors,
    shippingAddress,
    deliveryInstructions,
    originalRequestId,
  };
};
